module.exports = __webpack_public_path__ + "img/flag-CL.9bf5fd63.svg";